<script>
import { Lodash } from '@intelipost-js/secure-providers';
import { ScTable, ScTableColumn, ScTableEmpty, ScTag } from '@intelipost-js/secure-components';
import formatPTCurrency from '../../shared/CurrencyFormatter';

export default {
  name: 'billings-by-lp-table',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    billings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      emptyTableTemplate: `
        <p style="font-weight: bold; font-size: 1.5em">Nenhuma fatura encontrada</p>
        <p>Selecione um período diferente da data de vencimento ou adicione uma nova fatura</p>
      `,
    };
  },
  methods: {
    formatPTCurrency,
    getLogisticProviderName(logisticProviderId) {
      return this.$store.getters['logisticProviders/logisticProviderName'](logisticProviderId);
    },
    calculateDivergentPercentage(row) {
      if (!row.divergentBillingsTotalValue) return 0;
      return Number((row.divergentBillingsTotalValue / row.billingsTotalValue) * 100).toFixed(1);
    },
  },
  async created() {
    if (Lodash.isEmpty(this.$store.getters['logisticProviders/allDeliveryMethods'])) {
      await this.$store.dispatch('logisticProviders/getLogisticProviders', false);
    }
  },
  components: {
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScTag,
  },
};
</script>

<template>
  <div class="page-content__table">
    <p class="page-content__table__title">Por transportadora</p>
    <sc-table
      :loading="loading" :data="billings"
      :bordered="false" :hoverable="false" :striped="false" :scrollable="false">
      <template slot-scope="{ row }">
        <sc-table-column label="Transportadora" :centered="false">
          <router-link
            :to="`/recon/billing/logistic-providers/${row.logisticProviderId}`">
            {{ getLogisticProviderName(row.logisticProviderId) }}
          </router-link>
        </sc-table-column>
        <sc-table-column label="Faturas" :centered="false">
          {{ row.billingsCount }}
        </sc-table-column>
        <sc-table-column label="Valor das faturas" :centered="false">
          {{ formatPTCurrency(row.billingsTotalValue) }}
        </sc-table-column>
        <sc-table-column label="Quantidade de pedidos" :centered="false">
          {{ row.shipmentOrdersCount }}
        </sc-table-column>
        <sc-table-column label="Faturas com divergência" :centered="false">
          {{ row.divergentBillingsCount }}
        </sc-table-column>
        <sc-table-column label="Valor da divergência" :centered="false">
          <span>{{ formatPTCurrency(row.divergentBillingsTotalValue) }}</span>
          <sc-tag size="is-medium" type="is-danger is-light" rounded v-if="row.divergentBillingsTotalValue > 0">
            {{ calculateDivergentPercentage(row) }} %
          </sc-tag>
        </sc-table-column>
      </template>
      <template slot="empty">
        <sc-table-empty icon="far fa-box-open" :message="emptyTableTemplate"/>
      </template>
    </sc-table>
  </div>
</template>

<style scoped lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line

.page-content {
  &__table {
    margin-top: 1em;
    background: #ffff;
    padding: 32px;
    border-radius: 8px;

    &__title {
      color: $primary;
      font-size: 1.5em;
      font-weight: bold;
      margin-bottom: .5em;
    }

    td {
      color: #010906;
      font-size: 16px;
      font-weight: normal;
    }

    .tag:not(body) {
      background-color: #FFF0EA;
      color: #E46329;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/components/billings-by-provider-table/BillingsByLPTable.vue